import { HttpResponse } from "@angular/common/http";
import { ChangeDetectorRef, Component } from "@angular/core";
import {AttendanceService} from '../attendance.service'
import {AttendanceConstant} from '../attendance.constant'
import { CommonService } from "src/app/common.service";
import { AppService } from "src/app/app.service";
import { Constants } from "src/app/app.constants";

declare var $: any;
@Component({
    selector: 'app-team-leave-approval',
    templateUrl: './team-leave-approval.component.html',
    styleUrls: ['./team-leave-approval.component.css']
})

export class TeamLeaveApprovalComponent{
    constructor(private attendanceService : AttendanceService,
        private commonService :CommonService,
        private appService : AppService,
        private changeDetect: ChangeDetectorRef){
        
    }
    imageBaseUrl: string = Constants.IMAGE_BASE_URL;
    teamLeavesList : any[] =[];
    teamLeavesListAll : any [] =[];
    teamApprovalHeaderList :any[] = AttendanceConstant.Team_APPROVAL_COLUMN_HEADER_LIST;
    // leaveType : any[] = AttendanceConstant.LEAVE_TYPE_LIST;
    leaveType :any[] =[];
    statusList :any[]= AttendanceConstant.ATTENDANCE_STATUS_LIST;
    selectedStatus : any ={};
    LeaveTypeMap : any ={};
    teamLeavesMap : any={}
    isLoader: boolean = false;
    userList : any [] =[];
    fieldUserSearch : string = null;
    filteredData: { count: number, filteredList: any[] } = { count: 0, filteredList: [] };
    searchableHeaderKeys: any[] = ["userName"]
    imageUrl: string = Constants.IMAGE_BASE_URL;
    
   async ngOnInit() {
        let teamLeavesList = await this.appService.getAttendnaceTypeObject().catch(()=>{
           
        });
        // teamLeavesList ={}
        if(!$.isEmptyObject(teamLeavesList)){
            this.leaveType = teamLeavesList["list"];
            this.LeaveTypeMap = teamLeavesList["map"];
        }
       
        this.getTeamLeaves()
    }

    ngAfterContentInit(){
        // $(".content").mCustomScrollbar();
    }

    updateScrollBar(){
        // $(".content").mCustomScrollbar("update");
    }


    getTeamLeaves(){
        this.isLoader = true;
      this.attendanceService.getTeamLeave()
      .subscribe((res : HttpResponse<any>)=>{
        var data = res.body.leaves;
        this.processTeamLeaves(data);
        this.isLoader = false;
        // console.log(data)
      },(error)=>{
        this.isLoader = false;
      })  
    }


    processTeamLeaves(teamLeavesList){
        let colorArray = Constants.RANDOM_COLOR_CLASS;
       for(let obj of teamLeavesList){
         
           if(obj.leaveType){
               if(this.LeaveTypeMap[obj.leaveType] && this.LeaveTypeMap[obj.leaveType].name){
                obj["leaveTypeStr"] = this.LeaveTypeMap[obj.leaveType].name;
                }else{
                obj["leaveTypeStr"] ="-";
                }
               if(this.LeaveTypeMap[obj.leaveType] && this.LeaveTypeMap[obj.leaveType].colorCode){
                obj["leaveTypeColorCode"] = this.LeaveTypeMap[obj.leaveType].colorCode;
               }else{
                obj["leaveTypeColorCode"] =""
               }
              
           }else{
                obj["leaveTypeStr"] ="-";
                obj["leaveTypeColorCode"] =""
           }

           if(obj.status){
            obj["statusObject"] = this.statusList[obj.status-1];
            if(obj.status && AttendanceConstant.ATTENDANCE_STATUS_MAP[obj.status]){
                obj['statusStr'] = AttendanceConstant.ATTENDANCE_STATUS_MAP[obj.status].text;
                obj['statusClass'] = AttendanceConstant.ATTENDANCE_STATUS_MAP[obj.status].colorClass;
            }
           }else{
            obj["statusObject"] = this.statusList[0];
           }

           obj['randomColorClass'] = "";
           if(obj.userId){
                let i = obj.userId % colorArray.length;
                obj['randomColorClass'] =  colorArray[i];
            
            }
       
        //    obj["statusObject"] = this.statusList[obj.status-1];

           this.teamLeavesMap[obj.id] = Object.assign({}, obj);
       }
       this.teamLeavesList = teamLeavesList;
       this.teamLeavesListAll = teamLeavesList;
       let userList =  this.teamLeavesList ;
       userList = userList.filter(function (user) {
       
        if (!this[user.userId]) {
            this[user.userId] = true;
            return true;
        }
    }, Object.create(null));
       this.userList = userList;
    //    console.log(userList)
       this.updateScrollBar()
    }


    statusChange(userObject){
        let statusObj ={}
        if(userObject.statusObject){
            statusObj["status"] = userObject.statusObject.key;

            statusObj["id"] = userObject.id.toString();

            var message = "Are you sure you want to change the status?";
            var title = "Message"
            this.appService.showConfirmationPopup(title, message).then((result) => {
              if(result.value) {
                  
                this.attendanceService.leaveApproval(statusObj)
                .subscribe((res:HttpResponse<any>)=>{
                    this.teamLeavesMap[userObject.id] = Object.assign({}, userObject);
                    this.getTeamLeaves();
                    this.appService.showSuccessPopup("Success","Status updated Successfully.")
                },(error)=>{
    
                })
              }else{
                  
                  let userObjectcurrent = this.teamLeavesMap[userObject.id];

                  this.teamLeavesList.map((elem)=>{
                      if(elem.id == userObjectcurrent.id){
                          elem.statusObject = userObjectcurrent.statusObject
                      }
                  })
                //   console.log(this.teamLeavesList)
              }
        })
        }
       
       
    }


    getShortName(userInfo){
        if(userInfo && userInfo.userName){
            let shorName = this.commonService.nameSorting(userInfo.userName);
            if(shorName){
                return shorName;
            }
        }
        return "";
    }

    onSelectedUserChange(userObject) {
        this.teamLeavesList = [];
        var index = null;
       
        if(userObject.checked){
            userObject.checked = true;
        }else{
            userObject.checked = false;
        }
        
        if (this.userList && this.userList.length > 0) {
            var userIds = [];
            // for(let u of this.userList){
            //     if(u.checked){
            //         userIds.push(u.id);
            //     }
  
            // }
            for (index in this.userList) {
                if (this.userList[index].checked) {
                    userIds.push(this.userList[index].userId);
                }
               
            }
  
            for (let team of this.teamLeavesListAll) {
                if (userIds.includes(team.userId)) {
                    this.teamLeavesList.push(team);
                }
            }
            if (userIds.length == 0) {
                this.teamLeavesList = this.teamLeavesListAll;
            }
        } else {
            this.teamLeavesList = this.teamLeavesListAll;
        }
    }
}